

















import { CobrancaPixRetorno, GerarLinkResponse } from "@/services/consultores.service";
import Modal from "@/shared/components/modal.vue";
import { Component, VModel, Vue, Watch } from "vue-property-decorator";

interface StatePixCopiaCola {
  color: string;
  texto: string;
  icon: string;
}

const stateDefault: StatePixCopiaCola = {
  color: "#792f4c",
  texto: "Copiar url",
  icon: "mdi-content-copy",
};

const mapState: { [key: number]: StatePixCopiaCola } = {
  0: {
    color: "error",
    texto: "Falha ao copiar url, tente novamente mais tarde",
    icon: "mdi-close",
  },
  1: {
    color: "success",
    texto: "Url copiada com sucesso",
    icon: "mdi-check",
  },
};

@Component({
  components: {
    Modal,
  },
})
export default class LinkCobranca extends Vue {
  @VModel()
  charge!: GerarLinkResponse | null;
  copiadoSucesso: boolean | null = null;
  timeoutCopyState: number | null = null;

  get stateBotao() {
    return (
      (this.copiadoSucesso == null && stateDefault) ||
      mapState[+this.copiadoSucesso!]
    );
  }

  @Watch("charge")
  onChargeChange(charge: CobrancaPixRetorno | null) {
    const modal = this.$refs.modal as Modal;
    if (charge) {
      modal.open();
    } else {
      modal.close(false);
    }
  }

  copy() {
    this.copiadoSucesso = null;
    if (this.timeoutCopyState) clearTimeout(this.timeoutCopyState);

    navigator.clipboard
      .writeText(this.charge?.url || "")
      .then(() => {
        this.copiadoSucesso = true;
      })
      .catch(() => {
        this.copiadoSucesso = false;
      })
      .finally(() => {
        this.timeoutCopyState = setTimeout(
          () => (this.copiadoSucesso = null),
          5000
        );
      });
  }

  close() {
    this.charge = null;
    this.$emit("onClose");
  }
}
